const mutations = {
  panelState(state, arg) {
    state.panelState = arg;
  },
  userState(state, arg) {
    state.userState = arg;
    if (arg !== "signedIn") {
      state.accountExportEnabled = false;
    }
  },
  statementProcessorEnabled(state, enabled) {
    state.statementProcessorEnabled = enabled;
  },
  accountExportEnabled(state, enabled) {
    state.accountExportEnabled = enabled;
  },
};

export default mutations;
